<template>
  <div class="admin-wrap">
    <div class="header">
      <h3 class="text-left" style="margin-right: auto">New Attendance Report (Monthly)</h3>
      <div class="form">
        <div>
          Year:
          <select v-model="year">
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
        </div>
        <div>
          Month:
          <select v-model="month">
            <option v-for="(m, k) in months" :key="k" :value="k">{{ m }}</option>
          </select>
        </div>
      </div>
      <a :href="exportCsvUrl" download>Download CSV (v1)</a>
      <a href="#" @click="generateCsv()">Download CSV (v2)</a>
      <a :href="exportPdfUrl" download>Download PDF</a>
    </div>

    <table style="width: 100%; background: white">
      <tr>
        <th>Student</th>
        <th v-for="day in days" :key="day" style="white-space: nowrap">{{ formatDate(day) }}</th>
      </tr>

      <tr v-for="(row, s) in table" :key="s">
        <td v-html="studentInfo(s)"></td>
        <td v-for="day in days" :key="day" :set="r = row?.[day]?.[0]">
          <div v-if="r?.AttendanceStatus">
            <div class="mb" style="text-decoration: underline">
              <strong>{{ r.AttendanceStatus }}</strong>
            </div>
            <div class="mb">
              <strong>Check-In/Out:</strong><br />IN: &nbsp;&nbsp;&nbsp;{{ formatTime(r.CheckedInAt) }}<br />OUT: {{ formatTime(r.CheckedOutAt) }}
            </div>
            <div class="mb"><strong>Temperatures:</strong><br />{{ r.TemperatureDetails }}</div>
            <div class="mb">
              <strong>Remarks:</strong><br />
              <div>{{ r.Remarks }}</div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import DataSource from '@/data/datasource'
import { URLForEndpoint } from '@/data/requests'
import moment from 'moment'

export default {
  name: 'NewAttendanceReportMonthly',
  data() {
    return {
      years: Array.from({ length: moment().year() - 2022 }, (_, i) => 2023 + i),
      months: { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' },
      year: moment().year(),
      month: moment().month() + 1,
      table: [],
    }
  },
  computed: {
    params() {
      const school = Cookies.get('schoolSession')
      const userId = Cookies.get('userIDSession')
      const userType = Cookies.get('userTypeSession')

      return { school, from: this.fromDate.format('YYYY-MM-DD'), to: this.toDate.format('YYYY-MM-DD'), UserID_Session: userId, UserType_Session: userType }
    },
    exportCsvUrl() {
      return URLForEndpoint('/controller/Api.asmx/AttendanceReport', {
        ...this.params,
        token: Cookies.get('authToken'),
        download: 'csv',
      })
    },
    exportPdfUrl() {
      return URLForEndpoint('/controller/Api.asmx/AttendanceReport', {
        ...this.params,
        token: Cookies.get('authToken'),
        download: 'pdf',
      })
    },
    fromDate() {
      return moment(`${this.year}-${this.month}-01`)
    },
    toDate() {
      return this.fromDate.clone().add(1, 'months')
    },
    days() {
      const current = this.fromDate.clone()
      const dates = []
      while (current.unix() < this.toDate.unix()) {
        dates.push(current.format('YYYY-MM-DD'))
        current.add(1, 'days')
      }
      return dates
    },
  },
  watch: {
    year() {
      this.update()
    },
    month() {
      this.update()
    },
  },
  methods: {
    api(data = {}) {
      const payload = { ...this.params, ...data }
      return DataSource.shared.callWebService('/controller/Api.asmx/AttendanceReport', payload, 'POST')
    },
    async update() {
      this.table = []
      const rows = await this.api()
      const grouped = _.groupBy(rows, 'StudentID')
      _.forEach(grouped, (value, key) => {
        grouped[key] = _.groupBy(value, x => x.AttendanceDate.slice(0, 10))
      })
      this.table = grouped
    },
    formatDate(input) {
      return input ? moment(input).format('MMM DD, ddd') : '-'
    },
    formatTime(input) {
      return input ? moment(input).format('h:mm A') : '-'
    },
    studentInfo(studentId) {
      const byDates = Object.values(this.table[studentId])
      const r = byDates[0][0]
      return `${r.StudentName}<br><br>${r.ClassName}`
    },
    generateCsv() {
      let csv = ''
      const headers = ['Student']
      this.days.forEach(day => {
        headers.push(`\"${this.formatDate(day)}\"`)
      })
      csv += headers.join(',') + '\n'
      Object.keys(this.table).forEach(studentId => {
        const studentData = this.table[studentId]
        // Extract student name and class info from the first available record
        let studentName = ''
        let className = ''
        const dates = Object.keys(studentData)
        if (dates.length > 0 && studentData[dates[0]].length > 0) {
          studentName = studentData[dates[0]][0].StudentName
          className = studentData[dates[0]][0].ClassName
        }
        // Format the first column as "StudentName (ClassName)"
        const studentCell = `${studentName} (${className})`
        const row = [`"${studentCell.replace(/"/g, '""')}"`]

        // Loop through each day column
        this.days.forEach(day => {
          if (studentData[day] && studentData[day].length > 0) {
            // For this example, we use the first record for the day.
            const r = studentData[day][0]
            let cellData = ''
            cellData += r.AttendanceStatus || 'X'
            row.push(`"${cellData.replace(/"/g, '""')}"`)
          } else {
            row.push('"X"')
          }
        })

        csv += row.join(',') + '\n'
      })

      // Create a Blob with CSV data and trigger a download
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', `Attendance_Report_${this.year}_${this.month}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
  async mounted() {
    await this.update()
  },
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.form {
  display: flex;
  gap: 10px;
}

select,
input {
  height: 30px;
  padding-left: 6px;
  padding-right: 6px;
}

table {
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #888;
  text-align: left;
  padding: 4px 6px;
  line-height: 1.2;
  white-space: pre-line;
  min-width: 150px;
}

.mb {
  margin-bottom: 10px;
}
</style>
